<script>
  import { onMount } from "svelte";
  import Chart from "chart.js/auto";

  let id = Math.floor(Math.random() * 1000000).toString();
  let ctx;
  let myChart;
  let mounted = false;

  export let type = "doughnut"; //polarArea
  export let data;
  export let tooltip = true;

  $: {
    data;

    if (data && mounted) {
      draw();
    }
  }

  onMount(() => {
    mounted = true;
    if (data) {
      draw();
    }
  });

  function draw() {
    ctx = document.getElementById("myChart" + id.toString()).getContext("2d");

    if (myChart) {
      myChart.destroy();
    }

    // Chart.types.Doughnut.extend({
    //     name: "DoughnutAlt",
    //     draw: function () {
    //         Chart.types.Doughnut.prototype.draw.apply(this, arguments);

    //         console.log("override!!")

    //         // this.chart.ctx.textBaseline = "middle";
    //         // this.chart.ctx.fillStyle = 'black'
    //         // this.chart.ctx.font = "50px Roboto";
    //         // this.chart.ctx.textAlign = "center";
    //         // this.chart.ctx.fillText(distributionChartData[3] + " %", 135, 120);
    //         // this.chart.ctx.font = "20px Roboto";
    //         // this.chart.ctx.fillText((distributionChartData[0] + distributionChartData[1] + distributionChartData[2]) + " Responses", 135, 160);
    //     }
    // });

    // var pieChart = document.getElementById('myChart' + id.toString()).getContext('2d');
    // new Chart(pieChart).DoughnutAlt(data, {
    //     percentageInnerCutout: 80, animationEasing: "easeOutQuart"
    // });

    myChart = new Chart(ctx, {
      type: type,
      // options: config['options'],
      data: data,
      onAnimationComplete: new (function () {})(),
      options: {
        responsive: true,
        plugins: {
          title: {
            display: false,
            text: "",
          },
          tooltip: {
            mode: "index",
            enabled: tooltip,
          },
          legend: {
            display: false,
          },
        },
      },
      onClick: function () {},
    });

    // document.getElementById('myChart' + id.toString()).style.width = "250px";
    // document.getElementById('myChart' + id.toString()).style.height = "250px";
  }
</script>

<!-- <div class="wrapper"> -->
<canvas id="myChart{id}" />

<!-- </div> -->
<style>
  canvas {
    height: inherit;
    /*    width: inherit;*/
    padding-left: 0;
    padding-right: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: auto;
    margin-bottom: auto;
    display: block;
    width: 100px;
  }

  .wrapper {
    height: inherit;
    width: inherit;
    background-color: transparent;
  }
</style>
